
export default function WhyChooseUs() {
  const features = [
    {
      icon: "ri-fire-line",
      title: "Freshly Roasted",
      description: "Our coffee beans are roasted in small batches daily to ensure maximum freshness and flavor in every cup."
    },
    {
      icon: "ri-leaf-line",
      title: "Ethically Sourced",
      description: "We partner directly with farmers to ensure fair trade practices and sustainable growing methods."
    },
    {
      icon: "ri-map-pin-line",
      title: "Made in Delhi",
      description: "Proudly crafted in Delhi with love for our local community and coffee culture."
    },
    {
      icon: "ri-award-line",
      title: "Premium Quality",
      description: "Only the finest arabica beans and ceremonial grade matcha make it to our shelves."
    }
  ];

  return (
    <section id="why-us" className="py-20 bg-stone-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-stone-900 mb-4">
            Why Choose Roaffees?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            We're committed to bringing you the finest coffee and matcha experience in Delhi
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 text-center group">
              <div className="w-16 h-16 bg-gradient-to-br from-amber-600 to-amber-700 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${feature.icon} text-white text-2xl`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-stone-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
